// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1i1mq","empty":"ModalGraph_empty__2O5Xc"};